import React from "react";
import { Link } from "react-router-dom";
import { useLocalization } from "../hooks/useLocalization";

// Shared "record not found" state for any detail page keyed by a route param id. Without
// this, pages that only branch their fetch .catch() on 403 (access denied) leave the main
// data state permanently null on a 404, which renders an infinite loading spinner forever
// with no way to recover - confirmed as a real bug across multiple detail pages.
export const NotFoundState = ({ testId = "record-not-found", backTo, backLabel }) => {
  const { t } = useLocalization();
  return (
    <div className="text-center py-16" data-testid={testId}>
      <p className="text-lg font-semibold text-gray-800">{t("common.notFound")}</p>
      <p className="text-sm text-gray-500 mt-1">{t("common.recordNotFoundBody")}</p>
      {backTo && (
        <Link to={backTo} className="inline-block mt-4 text-sm font-semibold text-blue-600 hover:underline" data-testid={`${testId}-back-link`}>
          {backLabel || t("common.back")}
        </Link>
      )}
    </div>
  );
};
